import { cn } from 'noddi-ui-common';
import { NoddiIconButton } from 'noddi-ui-web';
import { useState } from 'react';
import { isLocal } from '../../constants/environment';

const BASE_URL = import.meta.env.VITE_APP_BE_URL;

export const APIBanner = () => {
  const isTestBackend = BASE_URL?.includes('https://dev.api.noddi.co') ?? false;
  const isProdBackend = BASE_URL?.includes('https://api.noddi.co') ?? false;

  const isLocalEnvAndProdBackend = isLocal && isProdBackend;

  const [showBanner, setShowBanner] = useState(isTestBackend || isLocalEnvAndProdBackend);

  if (!showBanner) {
    return null;
  }
  return (
    <div
      className={cn(
        'fixed top-0 left-0 z-dev-banner flex size-fit rounded-lg p-[0.5px]',
        isLocalEnvAndProdBackend ? 'bg-danger' : 'bg-success20'
      )}
    >
      <div className='flex items-center gap-2'>
        <div className='font-bold'>{isLocalEnvAndProdBackend ? 'PROD BE' : 'TEST BE'}</div>
        <NoddiIconButton variant='ghost' size='small' iconName='X' onClick={() => setShowBanner(false)} />
      </div>
    </div>
  );
};
